import { css } from '@emotion/core';
export var carousel = {
  name: "mro3c9",
  styles: "padding-left:8px;padding-right:8px;"
};
export var arrows = {
  name: "mdglon",
  styles: "margin:18px;&:hover{cursor:pointer;}"
};